import { useState, useEffect } from "react";
import Password from "./Password";
import "./styles.css";

function Map({ setActiveTab, solvedPuzzles, onResponse }) {
  const [locations, setLocations] = useState([
    { id: 1, name: "Start", x: 50, y: 70, unlockLevel: 0, unlocked: true },
    { id: 2, name: "Curty's Kookie", x: 150, y: 230, unlockLevel: 1, unlocked: false },
    { id: 3, name: "Track", x: 150, y: 360, unlockLevel: 2, unlocked: false },
    { id: 4, name: "Maintenance Hangar", x: 270, y: 390, unlockLevel: 3, unlocked: false },
    { id: 5, name: "Recording Studio", x: 400, y: 310, unlockLevel: 4, unlocked: false },
    { id: 6, name: "Psychiatric Hospital", x: 570, y: 390, unlockLevel: 5, unlocked: false },
    { id: 7, name: "Caves", x: 600, y: 260, unlockLevel: 6, unlocked: false },
    { id: 8, name: "Gym", x: 385, y: 55, unlockLevel: 7, unlocked: false },
    { id: 9, name: "???", x: 585, y: 75, unlockLevel: 8, unlocked: false },
  ]);

  const mapImage = `/img${Math.min(solvedPuzzles, 8)}.jpg`;

  // Update unlocked locations whenever solvedPuzzles changes
  useEffect(() => {
    setLocations((prev) =>
      prev.map((loc) =>
        loc.unlockLevel <= solvedPuzzles
          ? { ...loc, unlocked: true }
          : { ...loc, unlocked: false }
      )
    );
  }, [solvedPuzzles]);

  return (
    <div className="map">
      <h2>Map</h2>

      <div className="map-area" style={{ backgroundImage: `url(${mapImage})` }}>
        {locations.map((loc) => (
          <div
            key={loc.id}
            className={`location ${loc.unlocked ? "unlocked" : "locked"}`}
            style={{ left: `${loc.x}px`, top: `${loc.y}px` }}
            title={loc.name}
          >
            {loc.unlocked ? (
              <button className = "map-button"
                    onClick={() => setActiveTab(loc.name)}>{loc.name}</button>
            ) : (
              "🔒"
            )}
          </div>
        ))}
      </div>

      {/* just for testing */}
      <p>Current solved puzzles: {solvedPuzzles}</p>
      <Password onResponse = {onResponse}></Password>
    </div>
  );
}

export default Map;
